
<div *ngIf="loadingIcon" class="k-i-loading outer"></div>
